import { render } from "./RegistrationVerifyView.vue?vue&type=template&id=628e4e58&scoped=true&ts=true&lang=pug"
import script from "./RegistrationVerifyView.vue?vue&type=script&lang=ts&setup=true"
export * from "./RegistrationVerifyView.vue?vue&type=script&lang=ts&setup=true"

import "./RegistrationVerifyView.vue?vue&type=style&index=0&id=628e4e58&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628e4e58"]])

export default __exports__